import { currentFundingReasonFormNameGetters, fundingAmountGetters } from '@/store/modules/currentFormDetails/routines'

export default {
  [currentFundingReasonFormNameGetters.CURRENT_FORM_NAME]: state => state.currentFundingReasonFormName,
  [fundingAmountGetters.FUNDING_AMOUNT]: state => state.fundingAmount
}
